import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../services/user.service';
import { CommonDataService } from '../../../services/common-data.service';
import { AuthService } from '../../../services/auth.service';

declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-review-complete',
  templateUrl: './review-complete.component.html',
  styleUrls: ['./review-complete.component.scss']
})
export class ReviewCompleteComponent implements OnInit {

  pageName = "Registration Complete";

  modelForm: FormGroup;
  filesToUpload: Array<File> = [];
  modelName = 'User';
  modelData:any;

  constructor(
    private authService: AuthService,
    private formBuilder: FormBuilder,
    private router: Router,
    private _data: CommonDataService
  ) {  }

  ngOnInit() {
    $('#loader').show();

    this.modelForm = this.formBuilder.group({
      seller: [true]
    });

    let modelObject1 = new FormData();

    modelObject1.append('modelName', this.modelName);
    modelObject1.append('is_seller', this.modelForm.controls['seller'].value);

    this._data.dynamicFormPost(modelObject1, 'api-create-seller') 
      .pipe(first())
      .subscribe(
        data => {

          if(data['sellerProfile'] != undefined) {
            sessionStorage.setItem('BNFGSHGFGG', 'TYHH50545HSJSJ21FFSDGSFFFSBHSFVSTVS410045');
            this.authService.authDetailsChanged.next([]);
          }

          // this.modelData = data['cover']['model']['modelData']['formFieldsEntities'];

          // if(data['cover']['model']['modelData']['formFieldsEntities']['is_seller']) {
          //   //localStorage.setItem('BNFGSHGFGG', 'TYHH50545HSJSJ21FFSDGSFFFSBHSFVSTVS410045');
          //   sessionStorage['BNFGSHGFGG'] = 'TYHH50545HSJSJ21FFSDGSFFFSBHSFVSTVS410045';
          // }
        },
        error => {
          console.log(error);
          $('#loader').hide();
        },

        () => {
          iziToast.success({
              title: 'Success!',
              position: 'topRight',
              icon: 'icon-circle-check',
              message: 'Your registration completed successfuly.'
          });
          $('#loader').hide();
        }
      );
  }

}
